import { Routes, Route, Navigate } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";

import { Dashboard } from "@/pages/Dashboard";
import { Login } from "@/pages/Login";
import Home from "@/pages/Dashboard/Home";
import Chat from "@/pages/Dashboard/Chat";
import Tv from "@/pages/Tv";
import { Register } from "@/pages/Register";
import Thanks from "@/pages/Thanks";
import Affiliated from "@/pages/Dashboard/Affiliated";
import Coupon from "@/pages/Dashboard/Coupon";
import Perfil from "@/pages/Dashboard/Perfil";
import Link from "@/pages/Link";
import { UserProvider } from "@/context/UserContext";
import ResetPassword from "@/pages/ResetPassword";
import EmailConfirmation from "@/pages/EmailConfirmation";
import PixScreen from "@/pages/PixScreen";
import Admin from "@/pages/Admin";
import Analytics from "@/pages/Admin/Users";
import Users from "@/pages/Admin/Users";
import Invoice from "@/pages/Admin/Invoice";
import { AdminRoute } from "./AdminRoute";
import DetailedStatistics from "@/pages/Dashboard/DetailedStatistics";
import DetailedPlayer from "@/pages/Dashboard/DetailedPlayer";
import Payments from "@/pages/Admin/Payments";
import Tickets from "@/pages/Admin/Tickets";
import UserTickets from "@/pages/Dashboard/UserTickets";
import UserManager from "@/pages/Admin/UserManager";
import AfterRegister from "@/pages/ThankYou";
import HomeLp from "@/pages/home-lp";
import LandingPage1 from "@/pages/LandingPages/LandingPage1";
import PreselTelegran from "@/pages/LandingPages/PreselTelegram1";
import PreselTelegram from "@/pages/LandingPages/PreselTelegram1";
import Courses from "@/pages/Dashboard/Courses";
import SmartTickets from "@/pages/Dashboard/SmartTickets";
import Players from "@/pages/Dashboard/Players";
import DashboardV2 from "../pages/Dashboard/V2";
import NewLp from "@/pages/new-lp";

export function Router() {
  return (
    <Routes>
      <Route element={<UserProvider />}>
        <Route element={<Dashboard/>}>
          <Route index element={<DashboardV2 />}></Route>
          <Route
            path="chat"
            element={<PrivateRoute component={<Chat />} />}
          ></Route>
          <Route
            path="afiliado"
            element={<PrivateRoute component={<Affiliated />} />}
          ></Route>
          <Route
            path="cupons"
            element={<PrivateRoute component={<Coupon />} />}
          ></Route>
          <Route
            path="bilhete"
            element={<PrivateRoute component={<UserTickets />} />}
          ></Route>
          <Route
            path="smart-tickets"
            element={<PrivateRoute component={<SmartTickets />} />}
          ></Route>
          <Route
            path="detalhado/:matchId"
            element={<PrivateRoute component={<DetailedStatistics />} />}
          ></Route>
          <Route
            path="jogador/:playerId"
            element={<PrivateRoute component={<DetailedPlayer />} />}
          ></Route>
          <Route
            path="jogadores"
            element={<PrivateRoute component={<Players />} />}
          ></Route>
          <Route
            path="perfil"
            element={<PrivateRoute component={<Perfil />} />}
          ></Route>
          <Route
            path="cursos"
            element={<PrivateRoute component={<Courses />} />}
          ></Route>
          <Route path="v2" element={<DashboardV2 />} />
          <Route path="*" element={<Navigate to="./" />} />
        </Route>
      </Route>
      <Route path="/cuuh-negro069" element={<Tv />}></Route>
      <Route path="/resetar" element={<ResetPassword />} />
      <Route path="/confirmarEmail" element={<EmailConfirmation />} />
      <Route path="/obrigado" element={<Thanks />} />
      <Route path="/login" element={<Login />} />
      <Route path="adm" element={<Admin />}>
        <Route index element={<AdminRoute component={<Users />} />} />
        <Route path="invoice" element={<AdminRoute component={<Invoice />} />} />
        <Route path="payments" element={<AdminRoute component={<Payments />} />} />
        <Route path="tickets" element={<AdminRoute component={<Tickets />} />} />
        <Route path="userManager" element={<AdminRoute component={<UserManager />} />} />
        <Route path="*" element={<Navigate to="./" />} />
      </Route>
      <Route path="/" element={<DashboardV2 />} />
      <Route path="/link/:id" element={<Link />} />
      <Route path="/register" element={<Register />} />
      <Route path="/home-lp" element={<HomeLp />} />
      <Route path="/obrigado-registro" element={<AfterRegister />} />
      <Route path="/telaPix" element={<PixScreen />} />
      <Route path="/vitor-kawano" element={<LandingPage1 />} />
      <Route path="/vitor-kawano-pre" element={<PreselTelegram />} />
      <Route path="/new-lp" element={<NewLp />} />
    </Routes>
  );
}
